import { CityConfigDao } from "../dao";
import { CityConfig, Sector, Zone } from "../model";

export class CityConfigService {
  private readonly _cityConfigDao: CityConfigDao;

  public constructor(cityConfigDao: CityConfigDao) {
    this._cityConfigDao = cityConfigDao;
  }

  public async getCityConfig(): Promise<CityConfig> {
    try {
      return await this._cityConfigDao.getCityConfig();
    } catch (error) {
      throw error;
    }
  }

  public async getSectors(cityId: string): Promise<Sector[]> {
    try {
      return await this._cityConfigDao.getSectors(cityId);
    } catch (error) {
      throw error;
    }
  }

  public async getZones(cityId: string): Promise<Zone[]> {
    try {
      return await this._cityConfigDao.getZones(cityId);
    } catch (error) {
      throw error;
    }
  }
}

export default CityConfigService;
